import { useNavigate } from "flemo";
import { CrownIcon, SettingsIcon } from "lucide-react";

import { Badge } from "@/components/ui/badge";
import { Button } from "@/components/ui/button";
import { UserAvatar } from "@/components/UserAvatar";
import { useIsPlusQuery } from "@/hooks/queries";
import { trackEvent } from "@/lib/analytics";
import { selectAvatarUrl, selectDisplayName, useAuthStore } from "@/store/authStore";

export function Header() {
  const { push } = useNavigate();
  const name = useAuthStore(selectDisplayName);
  const photoURL = useAuthStore(selectAvatarUrl);
  const { data: isPlus = false } = useIsPlusQuery();

  return (
    <header className="flex items-center justify-between p-5 pt-2 max-w-3xl mx-auto">
      <div className="flex items-center gap-3">
        <UserAvatar src={photoURL} alt={name} className="size-10" />

        <div className="flex flex-col min-w-0">
          <p className="text-xs text-muted-foreground">Hello,</p>
          <div className="flex items-center gap-1.5">
            <p className="text-base font-semibold text-foreground leading-tight truncate">{name}</p>
            {isPlus && (
              <Badge className="gap-0.5 bg-primary/15 text-primary border-0 px-1.5 py-0">
                <CrownIcon className="size-2.5" />
                Plus
              </Badge>
            )}
          </div>
        </div>
      </div>

      <Button
        type="button"
        variant="ghost"
        size="icon"
        aria-label="설정"
        onClick={() => {
          void trackEvent("settings_opened", { source: "home" });
          push("/settings");
        }}
      >
        <SettingsIcon className="size-5 text-muted-foreground" />
      </Button>
    </header>
  );
}
